<template>
  <div>
    <div class="modal-overlay" id="modal-overlay"></div>
    <div class="modal" id="modal">

      <div class="container">

        <h2>Spiel verlassen?</h2>

        <div class="text">
          Sind Sie sicher, dass Sie das Spiel verlassen möchten?<br/>
          Ihr bisheriger Fortschritt wird nicht gespeichert.
        </div>

        <div class="buttons">

          <button
              @click.prevent.stop="resume"
              class="green glow">
<!--            <img src="../assets/icons_UI_chevron_left.svg" alt=""/>-->
            <span>Zurück zum Spiel</span>
          </button>

          <button
              @click.prevent.stop="restart"
              class="default">
            <span>neu starten</span>
          </button>

        </div>

      </div>

    </div>

    <div
        class="exit"
    >
      <button
          class="icon"
          @click.prevent.stop="resume"
      >
        <img src="../assets/icons_UI_chevron_left.svg" alt=""/>
      </button>
      <a href="#" @click.prevent.stop="resume">
        Zurück zum Spiel
      </a>
    </div>

  </div>
</template>

<script>

export default {
  name: "ExitModal",
  props: {},
  components: {},
  data() {
    return {}
  },
  methods: {
    resume() {
      this.$emit('resume');
    },
    restart() {
      this.$router.push('/');
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.text {
  line-height: 200%;
}

.buttons {
    display: flex;
  justify-content: center;
}

@media(min-aspect-ratio: 16/9) {
  .glow {
    margin-right: scaleVh(30);
  }
  .text {
    font-size: scaleVh(18);
    margin-top: scaleVh(40);
    margin-bottom: scaleVh(56);
  }

  // ----------- mobile

  .mobile {
    .text {
      width: scaleMobileVh(300);
      font-size: scaleMobileVh(14);
      line-height: scaleMobileVh(20);
      margin-top: scaleMobileVh(34);
      margin-bottom: scaleMobileVh(34);
    }
    h2 {
      margin-top: scaleMobileVh(0);
    }
  }
}

@media(max-aspect-ratio: 16/9) {
  .glow {
    margin-right: scaleVw(30);
  }
  .text {
    font-size: scaleVw(18);
    margin-top: scaleVw(40);
    margin-bottom: scaleVw(56);
  }

  .mobile {
    .text {
      width: scaleMobileVw(300);
      font-size: scaleMobileVw(14);
      line-height: scaleMobileVw(20);
      margin-top: scaleMobileVw(34);
      margin-bottom: scaleMobileVw(34);
    }
    h2 {
      margin-top: scaleMobileVw(0);
    }
  }
}


</style>